/**
 * Get a specific value from a CSS custom property.
 *
 * If custom properties are not supported by the browser, return the [defaultValue].
 *
 * @param name - Name of the CSS variable (including the -- prefix)
 * @param defaultValue - Default value to return if custom properties are not supported by the browser.
 * @returns {*}
 */
export default function getCssVariable(name, defaultValue) {
    if (!window.getComputedStyle) {
        return defaultValue;
    }

    let computedStyles = window.getComputedStyle(document.body);
    return computedStyles.getPropertyValue(name);
}
